package com.jingfangpai.contentEntity.model

import com.jingfangpai.common.data.model.IdName
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionEntityType
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionRelationType
import kotlinx.serialization.Serializable

@Serializable
class ContentConnections {
    var contentId:String?=null
    var entityType:ContentConnectionEntityType?=null
    var connectedEntities = setOf<ConnectedEntityInfo>()
}

@Serializable
data class ConnectedEntityInfo(
    var entityId:String? = null,
    var entityName:String? = null,
    var relationType: ContentConnectionRelationType? = null,
    var connectionId: String? = null
)